import type {ReactElement} from 'react';
import {ControlledListItemType8} from '@Components/controlled-list/components/controlled-list-item-type-8';
import {useAppDispatch, useAppSelector} from '@/hooks';
import type {LIST_ITEM_TYPE, ListDefaultItemBaseStorage} from '../../list.types';
import {updateListItemSelectionState} from '../../list-reducer';

interface ListItemType8Props {
  id: string;
  listId: string;
}

export interface ListItemType8Storage extends ListDefaultItemBaseStorage {
  type: LIST_ITEM_TYPE.DEFAULT_8;
}

export function ListItemType8({...props}: ListItemType8Props): ReactElement<any> | null {
  const dispatch = useAppDispatch();
  const listItemData = useAppSelector((state) => {
    return state.list.listItemData.listItemsHashMap[props.id] as ListItemType8Storage;
  });

  const handleClick = (): void => {
    dispatch(
      updateListItemSelectionState({
        listId: props.listId,
        id: props.id,
      })
    );
    if (listItemData.onClick) {
      listItemData.onClick(props.listId, props.id);
    }
  };

  return listItemData ? (
    <ControlledListItemType8
      id={listItemData.id}
      onClick={(_id, event) => {
        event?.stopPropagation();
        handleClick();
      }}
      className={listItemData.className}
      text={listItemData.text}
      isSelected={listItemData.isSelected}
    />
  ) : null;
}
